import apiClient from './apiClient';

export const listTasks   = ()            => apiClient.get('/tasks/').then(r => r.data);
export const createTask  = (payload)     => apiClient.post('/tasks/', payload).then(r => r.data);
export const updateTask  = (id, payload) => apiClient.put(`/tasks/${id}/`, payload).then(r => r.data);
export const deleteTask  = (id)          => apiClient.delete(`/tasks/${id}/`).then(r => r.data);

export const listTaskFiles   = (taskId)          => apiClient.get(`/tasks/${taskId}/files/`).then(r => r.data);
export const uploadTaskFile  = (taskId, formData) => apiClient.post(`/tasks/${taskId}/files/`, formData, { headers: { 'Content-Type': 'multipart/form-data' } }).then(r => r.data);
export const deleteTaskFile  = (fileId)          => apiClient.delete(`/tasks/files/${fileId}/`).then(r => r.data);

// Phase 3 — task automation engine
export const getTasksToAssume    = ()             => apiClient.get('/tasks/to-assume/').then(r => r.data);
export const claimTask           = (id)           => apiClient.post(`/tasks/${id}/claim/`, {}).then(r => r.data);
export const coordinatorDecision = (id, payload)  => apiClient.post(`/tasks/${id}/coordinator-decision/`, payload).then(r => r.data);
